import React from 'react';
import './Terms.css';  // Terms.css 재사용

const Privacy = () => {
	return (
		<div className="terms-container">
			<div className="terms-content">
				<h1>개인정보처리방침</h1>
				
				<section className="terms-section">
					<h2>제1조 (개인정보의 처리 목적)</h2>
					<p>
						wearToday(이하 "회사")는 다음의 목적을 위하여 개인정보를 처리합니다. 
						처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 
						이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 
						별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
					</p>
					<ol>
						<li><strong>회원 가입 및 관리</strong>
							<ul>
								<li>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증</li>
								<li>회원자격 유지·관리, 서비스 부정이용 방지</li>
								<li>각종 고지·통지, 고충처리</li>
							</ul>
						</li>
						<li><strong>재화 또는 서비스 제공</strong>
							<ul>
								<li>물품배송, 서비스 제공, 청구서 발송</li>
								<li>콘텐츠 제공, 맞춤 서비스 제공</li>
								<li>본인인증, 연령인증, 요금결제·정산</li>
							</ul>
						</li>
						<li><strong>마케팅 및 광고에의 활용</strong>
							<ul>
								<li>신규 서비스 개발 및 맞춤 서비스 제공</li>
								<li>이벤트 및 광고성 정보 제공 및 참여기회 제공</li>
								<li>인구통계학적 특성에 따른 서비스 제공 및 광고 게재</li>
							</ul>
						</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제2조 (개인정보의 처리 및 보유 기간)</h2>
					<ol>
						<li>회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</li>
						<li>각각의 개인정보 처리 및 보유 기간은 다음과 같습니다:
							<ul>
								<li><strong>회원 가입 및 관리:</strong> 회원 탈퇴 시까지 (단, 관계 법령 위반에 따른 수사·조사 등이 진행중인 경우에는 해당 수사·조사 종료 시까지)</li>
								<li><strong>재화 또는 서비스 제공:</strong> 재화·서비스 공급완료 및 요금결제·정산 완료시까지 (단, 다음의 사유에 해당하는 경우에는 해당 기간 종료시까지)
									<ul>
										<li>「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시·광고, 계약내용 및 이행 등에 관한 기록: 5년</li>
										<li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년</li>
										<li>대금결제 및 재화 등의 공급에 관한 기록: 5년</li>
									</ul>
								</li>
							</ul>
						</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제3조 (처리하는 개인정보의 항목)</h2>
					<p>회사는 다음의 개인정보 항목을 처리하고 있습니다:</p>
					<ol>
						<li><strong>회원 가입 및 관리</strong>
							<ul>
								<li>필수항목: 이메일, 비밀번호, 이름, 생년월일, 성별, 휴대전화번호</li>
								<li>선택항목: 주소, 개인통관고유부호</li>
							</ul>
						</li>
						<li><strong>재화 또는 서비스 제공</strong>
							<ul>
								<li>필수항목: 이름, 휴대전화번호, 배송지 주소, 개인통관고유부호</li>
								<li>결제정보: 신용카드 정보, 은행계좌 정보 등</li>
							</ul>
						</li>
						<li><strong>인터넷 서비스 이용과정에서 자동 생성되는 정보</strong>
							<ul>
								<li>IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문기록, 불량 이용기록 등</li>
							</ul>
						</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제4조 (개인정보의 제3자 제공)</h2>
					<ol>
						<li>회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</li>
						<li>회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다:
							<ul>
								<li><strong>배송업체</strong>
									<ul>
										<li>제공받는 자: 택배사 (CJ대한통운, 우체국택배 등)</li>
										<li>제공목적: 상품 배송</li>
										<li>제공항목: 수령인 이름, 주소, 연락처</li>
										<li>보유기간: 배송 완료 후 3개월</li>
									</ul>
								</li>
								<li><strong>결제대행업체</strong>
									<ul>
										<li>제공받는 자: KG이니시스, 토스페이먼츠 등</li>
										<li>제공목적: 결제 처리</li>
										<li>제공항목: 결제정보, 거래정보</li>
										<li>보유기간: 거래 종료 후 5년</li>
									</ul>
								</li>
							</ul>
						</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제5조 (개인정보처리의 위탁)</h2>
					<ol>
						<li>회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다:
							<ul>
								<li><strong>배송업무:</strong> CJ대한통운, 우체국택배</li>
								<li><strong>결제처리:</strong> KG이니시스, 토스페이먼츠</li>
								<li><strong>고객센터 운영:</strong> 카카오톡 채널</li>
							</ul>
						</li>
						<li>회사는 위탁계약 체결시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제6조 (정보주체의 권리·의무 및 행사방법)</h2>
					<ol>
						<li>정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다:
							<ul>
								<li>개인정보 열람요구</li>
								<li>오류 등이 있을 경우 정정 요구</li>
								<li>삭제요구</li>
								<li>처리정지 요구</li>
							</ul>
						</li>
						<li>제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체없이 조치하겠습니다.</li>
						<li>정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제7조 (개인정보의 파기)</h2>
					<ol>
						<li>회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</li>
						<li>정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.</li>
						<li>개인정보 파기의 절차 및 방법은 다음과 같습니다:
							<ul>
								<li><strong>파기절차:</strong> 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</li>
								<li><strong>파기방법:</strong>
									<ul>
										<li>전자적 파일 형태: 복원이 불가능한 방법으로 영구 삭제</li>
										<li>종이 문서: 분쇄기로 분쇄하거나 소각</li>
									</ul>
								</li>
							</ul>
						</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제8조 (개인정보의 안전성 확보조치)</h2>
					<p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다:</p>
					<ol>
						<li>관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육 등</li>
						<li>기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치</li>
						<li>물리적 조치: 전산실, 자료보관실 등의 접근통제</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제9조 (개인정보 보호책임자)</h2>
					<p>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다:</p>
					<ul>
						<li><strong>개인정보 보호책임자</strong>
							<ul>
								<li>성명: wearToday 대표</li>
								<li>연락처: cozip99@naver.com</li>
								<li>카카오톡: https://open.kakao.com/o/sJ2m9h3h</li>
							</ul>
						</li>
					</ul>
					<p>정보주체는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자로 문의하실 수 있습니다.</p>
				</section>

				<section className="terms-section">
					<h2>제10조 (개인정보 열람청구)</h2>
					<p>정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 회사는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.</p>
					<ul>
						<li>개인정보 열람청구 접수·처리 부서: 고객센터</li>
						<li>연락처: cozip99@naver.com</li>
					</ul>
				</section>

				<section className="terms-section">
					<h2>제11조 (권익침해 구제방법)</h2>
					<p>정보주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다:</p>
					<ul>
						<li><strong>개인정보 침해신고센터</strong> (한국인터넷진흥원 운영)
							<ul>
								<li>소관업무: 개인정보 침해사실 신고, 상담 신청</li>
								<li>홈페이지: privacy.kisa.or.kr</li>
								<li>전화: (국번없이) 118</li>
							</ul>
						</li>
						<li><strong>개인정보 분쟁조정위원회</strong>
							<ul>
								<li>소관업무: 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)</li>
								<li>홈페이지: www.kopico.go.kr</li>
								<li>전화: (국번없이) 1833-6972</li>
							</ul>
						</li>
						<li><strong>대검찰청 사이버범죄수사단</strong>: 02-3480-3573 (www.spo.go.kr)</li>
						<li><strong>경찰청 사이버안전국</strong>: 182 (http://cyberbureau.police.go.kr)</li>
					</ul>
				</section>

				<section className="terms-section">
					<h2>제12조 (개인정보 처리방침 변경)</h2>
					<ol>
						<li>이 개인정보 처리방침은 2025년 1월 1일부터 적용됩니다.</li>
						<li>이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.</li>
					</ol>
				</section>

				<div className="terms-footer">
					<p>최종 수정일: 2025년 1월 1일</p>
					<button onClick={() => window.history.back()} className="btn-back">
						← 돌아가기
					</button>
				</div>
			</div>
		</div>
	);
};

export default Privacy;